import {  useSelector } from "react-redux";
import useAutomix from './hooks/useAutomix';

// Communication Player <=> Library - Requests Automix State
function AutomixWrapper() {
  const api = useSelector(state => state.api);
  useAutomix(api); // init Store Automix Management
  return null;
}

export default AutomixWrapper;
